module.exports = __webpack_public_path__ + "img/roof.daf8c264.png";